import Button from 'components/Form/Button';
import { CoreContext } from 'context/CoreContext';
import PropTypes from 'prop-types';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { POST } from 'services/api';
import { Update } from 'services/financing-proposals';
import { FormText, Title } from 'ui/styled';
import Wrapper from '../Wrapper';
import { CompanyButtonContainer } from './styled';

const ModalSample = ({ banco, id, origem }) => {
  const { setModal } = useContext(CoreContext);
  const [loading, setLoading] = useState(false);
  const handleError = (error) => {
    const errorMessages = {
      400: 'Dados inválidos. Verifique as informações enviadas.',
      401: 'Você não tem permissão para realizar esta ação.',
    };
    const defaultError =
      'Ocorreu um erro ao processar a requisição. Tente novamente mais tarde.';
    const errorMessage = errorMessages[error.response?.status] || defaultError;
    toast.error(errorMessage);
  };
  const handleConfirmProposal = async () => {
    if (!banco?.id || !id) {
      toast.error(
        'Não foi possível confirmar. Informações da proposta ausentes.'
      );
      return;
    }
    setLoading(true);
    let payload;
    if (origem === 'proposta') {
      payload = {
        atualiza_vencedor: true,
        propostas_banco: {
          id: banco.id,
          aceito: true,
        },
      };
    } else {
      payload = {
        id: id,
        banco: {
          id: banco.id,
        },
      };
    }
    //Essa e a parte que faz o direcionamento para analise o jeito correto pelo react seria usando history.push='/financing-table/under-analysis';
    //porem tive que fazer forçado para funcionar.
    try {
      if (origem === 'proposta') {
        await Update({ data: payload }, id);
        toast.success('Proposta confirmada com sucesso.');
        setModal(null);
        window.location.href = '/financing-table/under-analysis';
      } else {
        await POST('/pre-proposal/atualizabancovencedor', payload, true);
        toast.success('Proposta confirmada com sucesso.');
        setModal(null);
        window.location.href = '/preproposal/PreproposalApproved';
      }
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Wrapper>
      <Title nomargin>Confirmação</Title>
      <FormText>Deseja confirmar essa proposta como vencedora?</FormText>
      <CompanyButtonContainer>
        <Button
          onClick={() => setModal(null)}
          disabled={loading}
          color="light-grey"
        >
          Cancelar
        </Button>
        <Button
          color="blue"
          onClick={handleConfirmProposal}
          disabled={loading}
          between
        >
          {loading ? (
            <>
              <span className="spinner" /> Confirmando...
            </>
          ) : (
            'Confirmar'
          )}
        </Button>
      </CompanyButtonContainer>
    </Wrapper>
  );
};
ModalSample.propTypes = {
  banco: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ModalSample;
